const trackFathom = (id) => {
  //@ts-ignore
  window?.fathom?.trackGoal(id, 0);
};

export default trackFathom;
